import { normalizeRole } from './roles';

const ADMIN_ROLES = new Set(['client_admin', 'branch_admin']);
const EMPLOYEE_ROLES = new Set(['loan_officer', 'loan_processor']);
const LEAD_GEN_ROLE = 'lead_gen';

const isPlatformRole = (role) => {
  const value = String(role || '').toLowerCase();
  return value.includes('platform');
};

export const SECTIONS = {
  ADMIN: 'admin',
  ADMIN_INVITATIONS: 'admin_invitations',
  EMPLOYEE: 'employee',
  CONSUMER: 'consumer',
  PIPELINE: 'pipeline',
  LOAN_INFORMATION: 'loanInformation',
};

export function canAccessSection(section, role) {
  const normalized = normalizeRole(role);
  const raw = String(role || '').toLowerCase();

  switch (section) {
    case SECTIONS.ADMIN:
    case SECTIONS.ADMIN_INVITATIONS:
    case SECTIONS.EMPLOYEE:
      return isPlatformRole(raw) || ADMIN_ROLES.has(normalized);

    case SECTIONS.LOAN_INFORMATION:
      return (
        ADMIN_ROLES.has(normalized) ||
        normalized === 'loan_officer' ||
        normalized === 'loan_processor' ||
        normalized === LEAD_GEN_ROLE
      );

    case SECTIONS.PIPELINE:
      return ADMIN_ROLES.has(normalized) || EMPLOYEE_ROLES.has(normalized);

    default:
      return true;
  }
}

export function enforceAccessOrRedirect(section, role, fallbackPath) {
  if (canAccessSection(section, role)) {
    return null;
  }
  return fallbackPath;
}
